const getCookie = (cname) => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}
const getURLParameter = (sParam, url) => {
  const sPageURL = !url ? window.location.search.substring(1) : url
  const sURLVariables = sPageURL.split('&')
  const firstUrl = sPageURL.split('?')
  const decoder = (param) => {
    try {
      return decodeURIComponent(param)
    } catch (e) {
      return param
    }
  }
  for (const i of sURLVariables) {
    const sParameterName = i.split('=')
    if (sParameterName[0] === sParam) {
      return decoder(sParameterName[1])
    }
  }
  for (const i of firstUrl) {
    const sParameterName = i.split('=')
    if (sParameterName[0] === sParam) {
      return decoder(sParameterName[1].replace(/&\w+/gi, ''))
    }
  }
  return null
}
const getScreenSize = () => {
  try {
    const dppx = window.devicePixelRatio ||
      (window.matchMedia &&
      window.matchMedia('(min-resolution: 2dppx), (-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5)').matches
        ? 2
        : 1) ||
      1
    return `${screen.width * dppx}x${screen.height * dppx}`
  } catch (err) {
    return 0
  }
}
const getDPI = () => {
  try {
    for (let i = 56; i < 2000; i++) {
      if (matchMedia('(max-resolution: ' + i + 'dpi)').matches) {
        return i
      }
    }
    return 2000
  } catch (err) {
    return 0
  }
}
const detectDevice = () => {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android'
  } else if (navigator.userAgent.match(/BlackBerry/i)) {
    return 'BlackBerry'
  } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    return 'Apple'
  } else if (navigator.userAgent.match(/IEMobile/i)) {
    return 'WindowsPhone'
  } else {
    return 'Desktop'
  }
}
const getGAClientID = () => {
  // GA4
  const gaCookie = getCookie('_ga');
  if (gaCookie) return gaCookie.split('.').slice(2).join('.')
  //GA UA
  const ga = window.ga
  if (typeof ga !== 'undefined') {
    try {
      const id = ga.getAll()[0].get('clientId')
      if (id) {
        return id
      }
    } catch (err) {
      // err
    }
  }
  return ''
}
const dispatchWindowEvent = (name, params) => {
  const event = new CustomEvent(name, { detail: params })
  window.dispatchEvent(event)
}
const loadGTM = (gtm) => {
  const load = (w, d, s, l, i) => {
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    if (f.parentNode) {
      f.parentNode.insertBefore(j, f)
    }
  }
  load(window, document, 'script', 'dataLayer', gtm)
}
const loadFBPixel = (pixel) => {
  const load = (f, b, e, v) => {
    if (f.fbq) {
      return
    }
    // @ts-ignore
    const n = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) {
      f._fbq = n
    }
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s.parentNode) {
      s.parentNode.insertBefore(t, s)
    }
  }
  load(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  const fbq = window.fbq
  fbq('init', pixel)
  fbq('track', 'PageView')
}
const getScript = (source, callback) => {
  let script = document.createElement('script')
  const prior = document.getElementsByTagName('script')[0]
  script.async = 1
  // @ts-ignore
  script.onload = script.onreadystatechange = (_, isAbort) => {
    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
      script.onload = script.onreadystatechange = null
      script = undefined
      if (!isAbort && callback) {
        setTimeout(callback, 0)
      }
    }
  }
  script.src = source
  if (prior.parentNode) {
    prior.parentNode.insertBefore(script, prior)
  }
}
const getStylesheet = (source) => {
  const head = document.head
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = source
  const s = head.firstChild
  head.insertBefore(link, s)
}

export { getCookie, setCookie, getURLParameter, getScreenSize, getDPI, detectDevice, getGAClientID, dispatchWindowEvent, loadGTM, loadFBPixel, getScript, getStylesheet }



// WEBPACK FOOTER //
// ./src/utils/common.js